import { useMediaQuery, useTheme } from '@mui/material';

export const useScreen = (): { isMobile: boolean; isTablet: boolean } => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));

  return { isMobile, isTablet };
};
